import { useOrganizationsServiceOrganizationsTeamsListKey } from '@organization/api/queries'
import { OrganizationsService } from '@organization/api/requests'
import { InfiniteSelect } from '@shared/components'
import { SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  parent?: string
} & SelectProps

export const TeamSelect = ({ parent, ...props }: Props) => {
  const { t } = useTranslation()

  return (
    <InfiniteSelect
      placeholder={t('form.placeholder.select_team')}
      apiCall={({ pageParam, pageSize, search }) =>
        OrganizationsService.organizationsTeamsList(
          ['logical_node'],
          undefined,
          parent,
          undefined,
          undefined,
          undefined,
          pageParam,
          undefined,
          pageSize,
          search
        )
      }
      getOption={({ name, id }) => ({ label: name, value: id })}
      queryKey={[useOrganizationsServiceOrganizationsTeamsListKey, parent]}
      {...props}
    />
  )
}
